var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M15.0013 2.5C15.4287 2.5 15.7809 2.8217 15.829 3.23615L15.8346 3.33333V5C15.8346 5.46024 15.4615 5.83333 15.0013 5.83333C14.5739 5.83333 14.2217 5.51163 14.1736 5.09718L14.168 5H10.8346V15.8333H11.668C12.0953 15.8333 12.4476 16.155 12.4957 16.5695L12.5013 16.6667C12.5013 17.094 12.1796 17.4463 11.7652 17.4944L11.668 17.5H8.33464C7.8744 17.5 7.5013 17.1269 7.5013 16.6667C7.5013 16.2393 7.823 15.8871 8.23745 15.8389L8.33464 15.8333H9.16797V5H5.83464C5.83464 5.42736 5.51294 5.77959 5.09849 5.82773L5.0013 5.83333C4.57394 5.83333 4.22171 5.51163 4.17358 5.09718L4.16797 5V3.33333C4.16797 2.8731 4.54106 2.5 5.0013 2.5C5.42867 2.5 5.78089 2.8217 5.82903 3.23615L5.83464 3.33333H14.168C14.168 2.8731 14.5411 2.5 15.0013 2.5Z",
    fill: "#409CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.720d00260ccc948cf849230272c443b9.svg";
export { ForwardRef as ReactComponent };